import { render, staticRenderFns } from "./CompaniesSelector.vue?vue&type=template&id=909d0876&scoped=true&"
import script from "./CompaniesSelector.vue?vue&type=script&lang=ts&"
export * from "./CompaniesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesSelector.vue?vue&type=style&index=0&id=909d0876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909d0876",
  null
  
)

export default component.exports